import { ContentfulLivePreviewProvider, useContentfulLiveUpdates } from "@contentful/live-preview/react";
import dayjs from "dayjs";
import React from "react";
import { Banner } from "@/components/Banner/Banner";
import { Footer } from "@/components/Footer/Footer";
import { Header } from "@/components/Header/Header";
import { Section } from "@/components/Html/Section";
import { TableOfContent } from "@/components/TableOfContent/TableOfContent";
import { TableOfContentItem } from "@/components/TableOfContent/type";
import { useDayjsToString } from "@/components/useDayjsToString";
import { News } from "@/lib/contentful/contentModel/news";
import { Article } from "./Article/Article";

interface Props {
  news: News;
  tableOfContent: TableOfContentItem[];
  bodyHtml: string;
}

export const Slug: React.FC<Props> = ({ news, tableOfContent, bodyHtml }) => {
  const date = useDayjsToString(dayjs(news.fields.date), "YYYY/MM/DD");
  const data = useContentfulLiveUpdates(news);

  return (
    <ContentfulLivePreviewProvider
      locale="en-US"
      enableInspectorMode={false}
      enableLiveUpdates={true}
      debugMode={false}
    >
      <Section>
        <Header className="fixed z-[1] w-full bg-white" isArticle />
        <main className="article-container !pb-[40px] !pt-[100px]">
          <div>
            <div className="flex gap-6">
              <div className="hidden w-1/5 xlp:block">
                <TableOfContent tableOfContent={tableOfContent} body={data.fields.body} isHomeHeader></TableOfContent>
              </div>
              <div className="w-full shrink-0 lg:w-2/3 xlp:w-3/5">
                <Article data={data} date={date} tableOfContent={tableOfContent} bodyHtml={bodyHtml} />
              </div>
              <div className="hidden h-[fit-content] w-1/3 lg:block xlp:w-1/5">
                <Banner></Banner>
              </div>
            </div>
          </div>
        </main>
        <Footer isArticle />
      </Section>
    </ContentfulLivePreviewProvider>
  );
};
